<template>
  <b-modal
    id="modal-select-receiver"
    hide-footer
    hide-header
    centered
    size="lg"
  >
    <div class="grid mt-1 mb-3 gap-4">
      <div class="text-xl text-black text-center">
        Pilih Penerima Broadcast Kamu!
      </div>
      <div class="text-center">
        Silahkan pilih Target Broadcast dari Grup Kontak
      </div>
    </div>
    <div class="border border-2 rounded-lg md:p-2 p-1 mt-2 border-[#E2E2E2]">
      <ReceiverMessage
        :is-for-modal="true"
        :is-loading="isLoading"
        :search-receiver="searchReceiver"
        :group-contact="groupContact"
        :disabled="groupContactIdsSelected.length > 0"
        @update:searchReceiver="handleSearchReceiver"
        @update:groupContactSelected="value => groupContactSelected = value"
        @nextDataGroup="getGroupContact(true)"
      />
      <div class="my-1">
        <div class="mb-[5px]">
          <span class="">Jumlah Penerima:</span> <span class="text-primary">{{ totalReceiver() }}</span>
        </div>
        <div class="mb-[5px]">
          <span class="font-bold text-[12px] leading-[150%] tracking-[0.5px] align-middle">Estimasi Biaya:</span> <span class="font-normal text-primary text-[15px] leading-[150%] tracking-[0.5px] align-middle">Rp.{{ formatBalance(countCost()) }}</span>
        </div>
        <div class="text-lg font-semibold">
          <span>Komchat Coins:</span> <span class="text-primary">Rp.{{ formatBalance(balance) }}</span>
        </div>
        <div
          v-show="countCost() > balance "
          class="text-primary"
        >
          *Coins kamu tidak cukup untuk melakukan broadcast, <span
            role="button"
            class="text-[#08A0F7] underline"
            @click="$bvModal.show('modal-top-up-komchat-coin')"
          >silahkan topup</span>
        </div>
      </div>
      <div class="flex mt-2 items-center gap-2">
        <div class="w-full">
          <b-button
            block
            class="!h-[38px]"
            variant="outline-primary"
            @click="$bvModal.hide('modal-select-receiver')"
          >
            Batal
          </b-button>
        </div>
        <div class="w-full">
          <b-button
            block
            :disabled="countCost() > balance || groupContactSelected.length === 0 || !idTemplate"
            variant="primary"
            @click="sendBroadcast"
          >
            <div class="flex justify-center gap-1 items-center">
              <img
                :src="disabled?'https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/send-2.svg' : 'https://storage.googleapis.com/komerce/assets/LP-Komchat/send-uhuy.svg'"
                alt="icon-send"
                width="16"
                srcset=""
              > <div>Kirim Broadcast </div>
            </div>
          </b-button>
        </div>
      </div>
    </div>
    <ModalTopUp
      @refreshSaldo="getBalance"
      @handleTopupWithQris="handleTopupWithQris"
    />
    <ScanQRIS
      :qr-bill-detail="dataQris"
      :is-custom="true"
      @paymentSuccess="handlePaymentSuccess"
    />
  </b-modal>
</template>

<script>
import ReceiverMessage from './ReceiverMessage.vue'
import { formatBalance } from '../config'
import { apiGetGroupContact } from '../service/api.groupContact.service'
import apiGetBalance from '../service/api.balance.service'
import { apiSendBroadcastForBrands } from '../service/api.broadcast.service'
import ModalTopUp from './ModalTopUp.vue'
import ScanQRIS from '../../../dashboard/modal/ScanQRIS.vue'

export default {
  components: {
    ReceiverMessage,
    ModalTopUp,
    ScanQRIS,
  },
  props: {
    idTemplate: {
      type: Number,
      default: 0,
    },
    groupContactIdsSelected: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      cursor: 0,
      limit: 20,
      searchReceiver: '',
      isLoading: false,
      isLastData: false,
      disabled: true,
      groupContact: [],
      debounce: null,
      balance: null,
      cost: null,
      groupContactSelected: [],
      formatBalance,
      dataQris: {},
    }
  },
  watch: {
    groupContactSelected() {
      if (this.groupContactSelected.length > 0) {
        this.disabled = false
      } else {
        this.disabled = true
      }
    },
    groupContact: {
      handler() {
        if (this.groupContactIdsSelected && this.groupContactIdsSelected.length > 0) {
          this.setSelectedContactsFromIds()
        }
      },
      deep: true,
    },
    groupContactIdsSelected: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          // Reset dan mulai pencarian jika ID berubah dan ada isinya
          this.groupContact = [] // Kosongkan list kontak saat ID berubah
          this.groupContactSelected = []
          this.isLastData = false
          this.cursor = 0
          this.getGroupContact(false, true) // isInitialLoad true untuk memicu setSelectedContactsFromIds
        } else {
          // Jika groupContactIdsSelected kosong, bersihkan pilihan
          this.groupContactSelected = []
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    // getGroupContact sudah dipanggil oleh watcher groupContactIdsSelected jika ada nilai awal
    // Jika tidak ada nilai awal di groupContactIdsSelected, kita mungkin tetap ingin memuat daftar kontak awal
    if (!this.groupContactIdsSelected || this.groupContactIdsSelected.length === 0) {
      this.getGroupContact(false, false) // Load halaman pertama tanpa mencoba memilih apa pun
    }
    this.getBalance()
  },
  methods: {
    handleTopupWithQris(data) {
      this.dataQris = data
      this.$bvModal.show('scanQris')
    },
    handlePaymentSuccess(message) {
      this.$bvModal.hide('scanQris')
      this.getBalance()
      this.$toast_success({ message })
      this.$emit('paymentSuccess')
    },

    setSelectedContactsFromIds() {
      if (this.groupContactIdsSelected && this.groupContactIdsSelected.length > 0 && this.groupContact && this.groupContact.length > 0) {
        // Gabungkan kontak yang sudah dipilih sebelumnya dengan yang baru ditemukan
        const currentSelectedIds = this.groupContactSelected.map(contact => contact.id)
        const newlyFoundContacts = this.groupContact.filter(
          group => this.groupContactIdsSelected.includes(group.id) && !currentSelectedIds.includes(group.id),
        )

        if (newlyFoundContacts.length > 0) {
          this.groupContactSelected = [...this.groupContactSelected, ...newlyFoundContacts]
        }

        const allFound = this.groupContactIdsSelected.every(id => this.groupContactSelected.some(contact => contact.id === id))

        if (!allFound && !this.isLastData && !this.isLoading) {
          this.getGroupContact(true, true)
        }
      }
    },

    async getGroupContact(isNextPage = false, isInitialLoad = false) {
      if (this.isLoading) return // Hindari pemanggilan ganda jika sedang loading

      if (!isNextPage) {
        this.cursor = 0
        // Reset groupContact hanya jika bukan initial load yang bertujuan untuk menambah data
        if (!isInitialLoad) {
          this.groupContact = []
        }
        // Reset groupContactSelected hanya jika ini bukan initial load yang dipicu oleh groupContactIdsSelected
        // atau jika groupContactIdsSelected memang kosong.
        if (!isInitialLoad || !this.groupContactIdsSelected || this.groupContactIdsSelected.length === 0) {
          this.groupContactSelected = []
        }
      } else if (this.isLastData) {
        return
      }

      this.isLoading = true
      try {
        const data = await apiGetGroupContact(
          this.searchReceiver,
          this.cursor,
          this.limit,
        )
        const newGroupContacts = data.data.data || []
        this.cursor = data.data.meta.pagination.next_cursor

        if (newGroupContacts.length < this.limit || !this.cursor) {
          this.isLastData = true
        } else {
          this.isLastData = false
        }

        if (isNextPage) {
          // Hindari duplikasi kontak jika ada yang sudah termuat
          const existingIds = new Set(this.groupContact.map(c => c.id))
          const uniqueNewContacts = newGroupContacts.filter(c => !existingIds.has(c.id))
          this.groupContact.push(...uniqueNewContacts)
        } else {
          this.groupContact = newGroupContacts
        }

        // Jika ini adalah load awal (atau bagian dari proses load berkelanjutan untuk groupContactIdsSelected)
        // dan groupContactIdsSelected ada, panggil setSelectedContactsFromIds.
        if (isInitialLoad && this.groupContactIdsSelected && this.groupContactIdsSelected.length > 0) {
          this.setSelectedContactsFromIds()
        }
      } catch (error) {
        this.$toast_error({ message: error?.response?.data?.meta?.message || 'Gagal memuat grup kontak' })
        if (!isNextPage) {
          this.groupContact = []
        }
      } finally {
        this.isLoading = false
      }
    },
    totalReceiver() {
      return this.groupContactSelected.map(item => item.total_contact).reduce((sum, current) => sum + current, 0)
    },
    handleSearchReceiver(value) {
      clearTimeout(this.debounce)

      // eslint-disable-next-line no-underscore-dangle
      this.debounce = setTimeout(() => {
        this.searchReceiver = value
        this.getGroupContact()
      }, 2000)
    },
    // Metode baru yang lebih efisien
    updateSelectedContactsFromIds() {
      // Filter groupContact yang id-nya ada di groupContactIdsSelected
      const selectedContacts = this.groupContact.filter(group => this.groupContactIdsSelected.includes(group.id))

      // Hanya update groupContactSelected jika ada data yang ditemukan
      if (selectedContacts.length > 0) {
        this.groupContactSelected = selectedContacts
      }

      // Jika tidak semua ID ditemukan dan masih ada data yang bisa dimuat, muat data berikutnya
      // tapi hanya jika belum mencapai data terakhir dan belum ada operasi loading yang berjalan
      if (selectedContacts.length < this.groupContactIdsSelected.length && !this.isLastData && !this.isLoading) {
        this.getGroupContact(true)
      }
    },

    async loadGroupContact(isNextPage = false) {
      if (!isNextPage) {
        this.cursor = 0
      } else if (this.isLastData) {
        return
      }

      this.isLoading = true
      try {
        const data = await apiGetGroupContact(
          this.searchReceiver,
          this.cursor,
          this.limit,
        )
        const groupContact = data.data.data
        this.cursor = data.data.meta.pagination.next_cursor

        if (groupContact.length < this.limit || this.cursor === undefined) {
          this.isLastData = true
        } else {
          this.isLastData = false
        }

        if (isNextPage) {
          this.groupContact.push(...groupContact)
        } else {
          this.groupContact = groupContact || []
        }
      } catch (error) {
        this.$toast_error({ message: error.response.data.meta.message })
        if (!isNextPage) {
          this.groupContact = []
        }
      } finally {
        this.isLoading = false
      }
    },
    async getBalance() {
      try {
        const { data } = await apiGetBalance()
        this.balance = data.data.balance
        this.cost = data.data.marketing_message_price
      } catch {
        this.toast_error({ message: 'Gagal mendapatkan data saldo' })
      }
    },
    countCost() {
      const total = this.totalReceiver()
      return total * this.cost
    },
    async sendBroadcast() {
      try {
        await apiSendBroadcastForBrands(
          this.idTemplate,
          this.groupContactSelected.map(item => item.id),
        )
        this.$toast_success({ message: 'Berhasil mengirim broadcast' })
        this.$emit('refresh')
        this.$bvModal.hide('modal-select-receiver')
      } catch {
        this.$toast_error({ message: 'Gagal mengirim broadcast' })
      }
    },
  },
}
</script>
